import { WSElementProps, WSPill } from "@wingspanhq/fe-component-library";
import { PayoutPreferences } from "@wingspanhq/payments/dist/interfaces";
import React from "react";

type Props = {
  payoutPreference: `${PayoutPreferences}`;
  // When set, the instant badge spells out the per-payout fee the user is
  // opting into (e.g. "Instant (2% fee)")
  feePercentage?: number;
} & WSElementProps;

export const BadgePayoutPreference: React.FC<Props> = ({
  payoutPreference,
  feePercentage,
  ...elementProps
}) =>
  payoutPreference === PayoutPreferences.Standard ? (
    <WSPill {...elementProps} text="Standard" type="light" icon="in" />
  ) : payoutPreference === PayoutPreferences.Instant ? (
    <WSPill
      {...elementProps}
      text={
        feePercentage === undefined
          ? "Instant"
          : `Instant (${feePercentage}% fee)`
      }
      type="dark"
      icon="instant"
    />
  ) : null;
